import React from 'react';
import styled from 'styled-components';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { InputProps } from './types';
import NumberInput from '../Shared/Form/NumberInput/NumberInput';

export interface NumberEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
    label?: string;
  }

function NumberEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
}: NumberEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledContainer>
          <NumberInput
            label={label}
            helperText={fieldState.error?.message}
            value={field.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => field.onChange(convertStringToNumber(e.target.value))}
          />
        </StyledContainer>
      )}
    />
  );
}

function convertStringToNumber(value: string): number {
  return parseFloat(value);
}


export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;
`;

export default NumberEditor;
